import { combineReducers } from 'redux';
import { pathOr, propOr } from 'ramda';
import byId from './byId';
import list from './list';

const brands = combineReducers({
  byId,
  list,
});

export default brands;

export const getBrand = (state, id) => pathOr({}, ['admin', 'brands', 'byId', id], state);

export const getBrandCurrency = (state, id) => propOr('', 'currency')(getBrand(state, id));
